import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createPin, showPin } from '~/config/routes';
import List from './List';
import Show from './Show';
import New from './New';
import { PinProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Pin() {
  return (
    <PinProvider>
      <Switch>
        <Route
          exact
          path={createPin.spec}
          render={(props) => (
            <>
              <Can I="new" a="Pins">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Pins">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showPin.spec}
          render={(props) => (
            <>
              <Can I="show" a="Pins">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Pins">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Pins">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Pins">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </PinProvider>
  );
}
export default Pin;
